export const environment = {
  CAEndpoint: 'https://api-qa.tetherall.io/clinician/',
  USEndpoint: 'https://api-qa.tetherall.io/clinician/',
  googleMapsKey: 'AIzaSyBxq_NmYsxR4N0GRzITE4J7sfZ79Im_El0',
  buildNumber: "29898203",  
  versionNumber: "5.4.11",  
  environment_deploy: 'qa',
  raygunKey: '43wdWdJaHTd1ENpkAYZ53g',
  authKey: '5c68363d-ddf9-45e9-9623-a39f7c7705c2',
  cryptoKey: '0278beb9-e7bb-4c64-917a-ebdcfc55f58c',
  posthogToken: 'phc_C7CtUKlKTfK5YgaWv9YgSpLeK6KWwX9hvH0MUnycbCX',
};
